import { SxProps, Theme } from '@mui/material';

const associatedList = { display: 'block' } satisfies SxProps<Theme>;

const associatedListItem = {
  display: 'block',
  pl: 2,
  '&::before': { content: '"• "' }
} satisfies SxProps<Theme>;

const jobDropdownWrapper = { flex: 1, minWidth: 0 } satisfies SxProps<Theme>;

// Blocking overlay shown while candidates are being added, so the user can't
// interact with (or accidentally dismiss) the form mid-submit.
const submitOverlay = {
  position: 'absolute',
  inset: 0,
  zIndex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '16px',
  px: '32px',
  textAlign: 'center',
  backgroundColor: 'rgba(255, 255, 255, 0.85)'
} satisfies SxProps<Theme>;

const submitOverlayProgress = {
  width: '100%',
  maxWidth: '320px'
} satisfies SxProps<Theme>;

export const addToJobModalSx = {
  associatedList,
  associatedListItem,
  jobDropdownWrapper,
  submitOverlay,
  submitOverlayProgress
};
